/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/payeh',
  name: 'Payeh',
  component: () => import('@/views/payeh/Index'),



}]
